import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreatePackagePurchaseCommand,
  GetAllPackagesCommand,
  GetAllPackagePurchaseByResidentIdCommand,
  UpdatePackagePurchaseCommand,
} from './package-purchase.commands';
import {
  CreatedPackagePurchaseEvent,
  GotAllPackagesEvent,
  GotAllPackagePurchaseByResidentIdEvent,
  UpdatedPackagePurchaseEvent,
} from './package-purchase.events';

@Injectable()
export class PackagePurchaseEffects {
  prefix = 'package-purchase';
  createPackagePurchaseCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllPackagesCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllPackagePurchaseByResidentIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  updatePackagePurchaseCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createPackagePurchaseCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreatePackagePurchaseCommand,
      CreatedPackagePurchaseEvent,
      this.prefix,
    );
    this.getAllPackagesCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllPackagesCommand,
      GotAllPackagesEvent,
      this.prefix,
    );
    this.getAllPackagePurchaseByResidentIdCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllPackagePurchaseByResidentIdCommand,
      GotAllPackagePurchaseByResidentIdEvent,
      this.prefix,
    );
    this.updatePackagePurchaseCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdatePackagePurchaseCommand,
      UpdatedPackagePurchaseEvent,
      this.prefix,
    );
  }
}
